/* eslint-disable react/prop-types, react/jsx-props-no-spreading */
import React from "react";
import { Select } from "./SelectComponents";

const CreativeFieldFilter = ({
  options,
  selectedCreativeFields,
  setSelectedCreativeFields,
}) => {
  return (
    <Select
      placeholder={I18n.t("job_board_filters.generic.creative_field")}
      options={options}
      valueFunction={(creativeField) => ({
        label: I18n.t(`categories.${creativeField}`),
        value: creativeField,
      })}
      selectedOptions={selectedCreativeFields}
      setSelectedOptions={setSelectedCreativeFields}
    />
  );
};

export default CreativeFieldFilter;
